import { createContext } from 'react';
import { decorate, observable, action, toJS } from 'mobx';
import moment from 'moment';

import api from '../api';
import * as fn from '../utilities/_functions';

export class ServiceCreate {
    data = {};
    types = [];
    options = [];
    taxRates = [];
    hasUnsavedChanges = false;
    isReady = false;
    isSaving = false;
    saveToServer = true;

    cancelServiceCreate = null;
    cancelTaxRates = null;

    initialize = (saveToServer) => {
        const that = this;
        this.clear();

        return new Promise((resolve, reject) => {
            api.TaxRates.get(moment().format('YYYY-MM-DD'), (c) => { that.cancelTaxRates = c })
                .then(({ data }) => {
                    that.taxRates = data && data.length > 0 ? data : [];

                    if (!fn.isNullOrUndefined(saveToServer)) {
                        that.saveToServer = saveToServer;
                    }

                    resolve();
                })
                .catch((error) => {
                    reject(error);
                })
                .finally(() => {
                    this.isReady = true;
                })
        })
    }

    save = async (notify) => {
        if (!!notify) {
            this.isSaving = true;
        }

        if (this.hasUnsavedChanges) {
            try {
                let option = toJS(this.data);
                option.fee = isNaN(option.fee) ? fn.parseCurrency(option.fee) : option.fee;
                await api.Services.create(option, (c) => { this.cancelService = c });
                this.hasUnsavedChanges = false;
                return this.data;
            }
            finally {
                this.isSaving = false;
            }
        }
        this.isSaving = false;
    }

    clear = () => {
        this.data.colorHexValue = '#00acc1';
        this.data.name = null;
        this.data.code = null;
        this.data.feeCode = null;
        this.data.subsidyCode = null;
        this.data.minAgeRestriction = null;
        this.data.maxAgeRestriction = null;
        this.data.isFullExam = null;
        this.data.isBookable = null;
        this.data.isRepeatable = null;
        this.data.defaultApplyTax = null;
        this.data.defaultApplyTax2 = null;
        this.data.defaultApplyTax3 = null;
        this.data.subsidizedEligibilityUnit = null;
        this.data.subsidizedEligibilityType = null;
        this.data.defaultDurationInMinutes = 0;
        this.data.defaultRecallPeriodInMonth = null;
        this.data.defaultPrescriptionExpireInMonths = null;
        this.data.fee = null;
        this.data.timelineItems = [];
        this.data.examPublishedTemplateId = null;
        this.data.examTemplateId = null;
        this.data.sendReminder = null;
        this.data.reminderOffset = 0;
        this.data.sendReview = true;
        this.data.activeStartingDate = null;
        this.hasUnsavedChanges = false;
        this.types = [];
        this.options = [];
        this.taxRates = [];
        this.isReady = false;
        this.isSaving = false;
        this.saveToServer = true;

        if (fn.isFunction(this.cancelServiceCreate)) {
            this.cancelServiceCreate();
            this.cancelServiceCreate = null;
        }

        if (fn.isFunction(this.cancelTaxRates)) {
            this.cancelTaxRates();
            this.cancelTaxRates = null;
        }
    }
}

decorate(ServiceCreate, {
    data: observable.deep,
    types: observable,
    options: observable,
    taxRates: observable,
    hasUnsavedChanges: observable,
    isReady: observable,
    isSaving: observable,
    saveToServer: observable,
    initialize: action,
    save: action,
    clear: action,
})

export default createContext(new ServiceCreate());